import { render, staticRenderFns } from "./ReviewAvatar.vue?vue&type=template&id=55220d47&scoped=true"
import script from "./ReviewAvatar.vue?vue&type=script&lang=js"
export * from "./ReviewAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55220d47",
  null
  
)

export default component.exports